import { useWSInfiniteQuery, WSInfiniteQueryConfig } from "@ws-react-query";
import { ListRequestQuery, WSServiceError } from "../../../utils/serviceHelper";
import { getInsuranceCoverages } from "../../../services/api/insurance/coverage/getInsuranceCoverages";
import {
  IInsuranceCoverage,
  IInsuranceCoverageListRequestFilter,
  IInsuranceCoverageListRequestSort
} from "../../../services/api/insurance/coverage/types";

export const QUERY_INSURANCE_COVERAGES = "QUERY_INSURANCE_COVERAGES";

export const useQueryInsuranceCoverages = (
  params?: ListRequestQuery<
    IInsuranceCoverageListRequestFilter,
    IInsuranceCoverageListRequestSort
  >,
  config?: WSInfiniteQueryConfig<IInsuranceCoverage[], WSServiceError>
) => {
  const size = params?.page?.size || 10;

  return useWSInfiniteQuery(
    [QUERY_INSURANCE_COVERAGES, params],
    ({ pageParam = 1 }) => {
      return getInsuranceCoverages({
        filter: params?.filter,
        page: {
          size,
          number: pageParam
        },
        sort: params?.sort
      });
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage.length < size) {
          return undefined;
        } else {
          return allPages.length + 1;
        }
      },
      ...config
    }
  );
};
